var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section hero is-fullheight is-error-section",attrs:{"id":"particles-js"}},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column is-two-fifths"},[_vm._t("default")],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }